import { render, staticRenderFns } from "./LocaleButton.vue?vue&type=template&id=a84402b4&scoped=true&"
import script from "./LocaleButton.vue?vue&type=script&lang=js&"
export * from "./LocaleButton.vue?vue&type=script&lang=js&"
import style0 from "./LocaleButton.vue?vue&type=style&index=0&id=a84402b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84402b4",
  null
  
)

export default component.exports